__turbopack_context__.v({
  "brighten": "ASi1Kq_brighten",
  "end": "ASi1Kq_end",
  "fadeIn": "ASi1Kq_fadeIn",
  "isLoading": "ASi1Kq_isLoading",
  "slideDown": "ASi1Kq_slideDown",
  "slideUp": "ASi1Kq_slideUp",
  "start": "ASi1Kq_start",
  "wacky": "ASi1Kq_wacky",
});
